module.exports = __webpack_public_path__ + "img/sm_1.3fdeea5a.png";